/*
 * "Fabric & care" dialog (snippets/pv-fabric-care.liquid). Apply pack
 * 2026-10-01, change C26. Native <dialog>: Escape closes it, focus returns to
 * the button that opened it, a click on the backdrop closes it.
 */
(function () {
  if (window.pvFabricCareReady) return;
  window.pvFabricCareReady = true;

  var lastTrigger = null;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-pv-fabric-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-pv-fabric-open'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      lastTrigger = opener;
      dialog.showModal();
      return;
    }

    var closer = event.target.closest('[data-pv-fabric-close]');
    if (closer) {
      var open = closer.closest('dialog');
      if (open) open.close();
      return;
    }

    if (event.target.matches && event.target.matches('dialog[data-pv-fabric-dialog][open]')) {
      event.target.close();
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target.matches && event.target.matches('dialog[data-pv-fabric-dialog]') && lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    },
    true
  );
})();
